export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=708085de90318b1e3a17363f734d4f183814363aeb&name=pushAdClickData!'